import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {
  BUTTON_NAME
} from "@/constants";
import temp from "./temp";
import {
  Token,
  ClearToken
} from '@/utils/token';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    temp
  },
  state: {
    startLoading: 0,
    globalLoading: 0,
    errorLoading: 0,
    // 用户详细信息
    userInfo: null,
    addressDetail: null,
    ossKey: null,
    //恐龙蛋数量
    blance: null,
    // 产品详情
    projectDetail: null,
    BUTTON_NAME: BUTTON_NAME,
    TipShow: true,
    TipShowBottom: true,
    CodeShow: false,
    /* 用户认证和企业认证列表 */
    bookInfo: null,
    temp: {
      SelectCategory: {}
    },
    activePath: '',
    msgCount: 0,
    group_list: null,  // 项目成员
    permission: null,  // 根据角色获得权限列表
  },
  mutations: {
    SET_USER(state, data) {
      state.userInfo = data
    },
    START_LOADING(state) {
      state.startLoading++;
    },
    STOP_LOADING(state) {
      state.startLoading--;
    },
    // 全局loading
    START_GLOBAL_LOADING(state) {
      state.globalLoading++;
    },
    ERROR_LOADING(state) {
      state.errorLoading++;
    },
    STOP_GLOBAL_lOADING(state) {
      state.globalLoading--;
    },
    STOP_ERROR_LOADING(state) {
      state.errorLoading = 0;
    },
    USER_INFO(state, data) {
      state.userInfo = data;
    },
    CLEAR_USER_INFO(state) {
      state.userInfo = null;
    },
    // address
    GET_ADDRESS(state, data) {
      state.addressDetail = data;
    },
    GET_OSS_KEY(state, data) {
      state.ossKey = data;
    },
    GET_BLANCE(state, data) {
      state.blance = data;
    },
    GET_BOOK_INFO(state, data) {
      state.bookInfo = data;
    },

    GET_PROJECT_DETAILS(state, data) {
      state.projectDetail = data;
    },

    MATCH_BUTTON_LOADING(state, btn) {
      state.BUTTON_NAME[btn] = true;
    },
    RELIEVE_BUTTON_LOADING(state, btn) {
      state.BUTTON_NAME[btn] = false;
    },
    TIP_SHOW(state, data) {
      state.TipShow = data;
    },
    TIP_SHOW_BOTTOM(state, data) {
      state.TipShowBottom = data;
    },
    CODE_SHOW(state, data) {
      state.CodeShow = data;
    },
    GET_WECHAT(state, data) {
      Vue.set(state, "wechatData", data);
    },
    GET_ACTIVE_PATH(state, data) {
      state.activePath = data
    },
    GET_MSG_COUNT(state, data) {
      state.msgCount = data
    },

    PERMISSION(state, data) {
      state.permission = data
    },

    GROUP_LIST(state, data) {
      state.group_list = data
    }
  },
  actions: {
    set_user: ({
      commit
    }) => {
      commit("SET_USER");
    },
    startLoading: ({
      commit
    }) => {
      commit("START_LOADING");
    },
    stopLoading: ({
      commit
    }) => {
      commit("STOP_LOADING");
    },
    // loading num
    startGlobalLoading: ({
      commit
    }) => {
      commit("START_GLOBAL_LOADING");
    },
    // err loading
    errorLoading: ({
      commit
    }) => {
      commit("ERROR_LOADING");
    },
    stopErrorLoading: ({
      commit
    }) => {
      commit("STOP_ERROR_LOADING");
    },
    // stop laoding
    stopGlobalLoading: ({
      commit
    }) => {
      commit("STOP_GLOBAL_lOADING");
    },
    getUserInfo: ({
      commit
    }) => {
      const promise = axios.get("/designer_api/user/info");
      promise
        .then(res => {
          commit("USER_INFO", res);
        })
        .catch(() => {
          commit("CLEAR_USER_INFO");
        });
      return promise;
    },
    getAddress: ({
      commit
    }) => {
      const address = Vue.ls.get("ZHULOGIC_ADDRESS");
      if (!address) {
        const promise = axios.get("/designer_api/location");
        promise.then(res => {
          commit("GET_ADDRESS", res);
          Vue.ls.set("ZHULOGIC_ADDRESS", res, 2592000000);
        });
      } else {
        commit("GET_ADDRESS", address);
      }
    },
    getOssKey: ({
      commit
    }, type) => {
      const promise = axios.get("/designer_api/files/policy?type=" + type);
      promise.then(res => {
        commit("GET_OSS_KEY", res);
      });
    },

    // 获得恐龙蛋数量
    getBlance: ({
      commit
    }) => {
      const promise = axios.get("/designer_api/points/balance");
      promise.then(res => {
        commit("GET_BLANCE", res);
      });
    },

    /* 获得用户实名认证和企业认证列表 */
    getBookInfo: ({
      commit
    }) => {
      const promise = axios.get("/designer_api/user/auth_identity");
      promise.then(res => {
        if (res && res.length > 0) {
          res.forEach(element => {
            if (element.type === 1) {
              element.authName = element.authName + '（仅个人操作）'
            } else {
              element.authName = element.authName + '（支持团队协作）'
            }
          });
        }
        commit("GET_BOOK_INFO", res);
      });
    },

    /* 团队项目成员列表 */
    groupLists: ({commit}, id) => {
      const promise = axios.get(`/designer_api/project/team/${id}`);
      promise.then(res => {
        commit("GROUP_LIST", res);
      })
    },

    /* 获取权限列表 */
    permission:({commit}, prams) => {
      let promise;
      if(prams.projectId && prams.orderId) {
        promise = axios.get(`/designer_api/project/team/project/permission?projectId=${prams.projectId}&orderId=${prams.orderId}`);
      }else if(prams.projectId && !prams.orderId) {
        promise = axios.get(`/designer_api/project/team/project/permission?projectId=${prams.projectId}`);
      }else if(!prams.projectId && prams.orderId) {
        promise = axios.get(`/designer_api/project/team/project/permission?projectId=${prams.orderId}`);
      }
      promise.then(list => {
        if(!list || list.length === 0) return false
        const newAry = [];
        list.forEach((item,index) => {
            if(item.childPermission && item.childPermission.length > 0 ) {
                item.childPermission.forEach(ele => {
                    newAry.push(ele.permission)
                })
            }
        });
        commit("PERMISSION", newAry);
      })
    },

    // 产品详情
    getProjectDetails: ({
      commit
    }, data) => {
      commit("GET_PROJECT_DETAILS", data);
    },

    //匹配按钮loading
    matchButtonLoading: ({
      commit
    }, button) => {
      commit("MATCH_BUTTON_LOADING", button);
    },

    // 解除按钮 loading
    relieveButtonLoading: ({
      commit
    }, button) => {
      commit("RELIEVE_BUTTON_LOADING", button);
    },
    actiontipshow: ({
      commit
    }, data) => {
      commit("TIP_SHOW", data);
    },
    tipshowBootom: ({
      commit
    }, data) => {
      commit("TIP_SHOW_BOTTOM", data);
    },
    actiontipcodeshow: ({
      commit
    }, data) => {
      commit("CODE_SHOW", data);
    },
    //设置wechat
    getwechatvuex: ({
      commit
    }, data) => {
      commit("GET_WECHAT", data);
    },
    // 设置激活activePath
    getActivePath: ({
      commit
    }, data) => {
      commit("GET_ACTIVE_PATH", data);
    },
    // 未读消息数量
    getMsgCount: ({
      commit
    }) => {
      if (Token()) {
        const promise = axios.get("/designer_api/notices/sum/v2");
        promise.then(res => {
          commit("GET_MSG_COUNT", res);
        })
      }
    }
  },
  getters: {
    unReadMsg: state => state.msgCount
  }
});